import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";

const cropTypeChartFunc = (divRef, ndx = ndx) => {
  var OptionsDim = ndx.dimension((d) => {
    return d.options;
  });

  const selectChart = dc.selectMenu(divRef);
  selectChart
    .dimension(OptionsDim)
    .group(OptionsDim.group())
      .on("filtered", function (chart, filter) {
          var sel = chart.filterPrinter()(chart.filters());
          window.MSSELECROPTYPE = sel
          // console.log("selected filters are:" + sel);
      })
    .title((d) => d.key)
    .controlsUseVisibility(true);

  return selectChart;
};

export const SelectCropChart = (props) => (
  <ChartTemplate
    chartFunction={cropTypeChartFunc}
    // title="Gender of Financing Recipient"
    name="Select Option"
  />
);
